/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_ParticipantActivities_ParticipantActivitiesDto } from '../models/Wealthlane_Dtos_ParticipantActivities_ParticipantActivitiesDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * @returns Wealthlane_Dtos_ParticipantActivities_ParticipantActivitiesDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppDashboardAdminDashboard(): CancelablePromise<Wealthlane_Dtos_ParticipantActivities_ParticipantActivitiesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/dashboard/admin-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
